import { useState } from "react";
import { Form, Flex } from "antd";

import { changePassword } from "services";
import { useStores } from "stores";
import { ChangePasswordForm } from "components";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { parseErrorMessage } from "utils";

type FieldType = {
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
};

export const ChangePasswordModal = () => {
  const { actionModals } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const closeModal = () => {
    actionModals.closeAll();
  };

  const onFinish = () => {
    const values: FieldType = form.getFieldsValue();

    setLoading(true);

    changePassword(values)
      .then(() => {
        openNotification({
          message: "Пароль успешно изменен",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        closeModal();
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Flex align="center" vertical gap="large">
      <ChangePasswordForm form={form} disabled={loading} onFinish={onFinish} cancelHandler={closeModal} />
    </Flex>
  );
};
